import { Contact, Note } from '../types';

export class LotDetail {
    lotId: number;
    scarStart?: Date;
    scarFinal?: Date;
    phaseRelease: string;
    phaseNumber: string;
    releaseNumber: string;
    ownerEmail: string;
    ownerPhoneNumber: string;
    fieldContacts: Contact[];
    fieldContactNames: string;
    planTemplateName: string;
    buildingNumber: string;
    permitNumber: string;
    elevationHanding: string;
    prodType: string;
    jobId: number;
    isScheduleActive?: boolean;
    hasSchedule: boolean;
    notes: Note[];
}